import { Button } from '@/components/ui/button'
import { useAuth } from './AuthProvider'

/**
 * The genuine dead end: signed in, and the backend recognises the account as neither a
 * member nor a client's portal user.
 *
 * It deliberately names no domain. It used to say "only available to @taptalent.ai
 * accounts", which was untrue the moment client portals existed — and read, to a client, as
 * the product being shut to them.
 */
export function NoAccessPage({ reason }: { reason?: string }) {
  const { email, signOut } = useAuth()

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 shadow-e3">
        <h1 className="text-lg font-semibold tracking-tight">You don’t have access yet</h1>
        <p className="mt-2 text-sm text-muted-foreground">{reason ?? 'This account is not set up for Tapwork yet.'}</p>
        {email ? (
          <p className="mt-4 rounded-md bg-muted px-3 py-2 text-xs text-text-secondary">
            Signed in as <span className="font-medium">{email}</span>
          </p>
        ) : null}
        <p className="mt-4 text-xs text-muted-foreground">
          If you think this is a mistake: colleagues should ask a workspace admin to invite
          them, and clients should ask their contact to add their email domain to the portal.
        </p>
        <Button variant="outline" className="mt-6 w-full" onClick={() => void signOut()}>
          Sign out and try another account
        </Button>
      </div>
    </div>
  )
}
